import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/data-settings`

export async function latestJobRun() {
  const url = `${URL}/last-updated`

  return getWithRedirect<{ latest_job_run: string | null }>(url)
}
